import React from 'react';

const DryingCharacterSection = ({
  displayData,
  handbooks,
  openDryingCharacterPicker,
  handleUserInfoChange
}) => {
  return (
    <div style={{ marginTop: '20px' }}>
      <h3 style={{ 
        margin: '0 0 15px 0', 
        fontSize: '16px', 
        fontWeight: '600', 
        color: '#333'
      }}>
        Информация
      </h3>
      
      <div style={{ 
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        backgroundColor: '#fff'
      }}>
        <table style={{
          width: '100%',
          minWidth: '800px',
          borderCollapse: 'collapse',
          fontSize: '12px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th style={{ 
                minWidth: '400px', 
                width: '400px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                Характер усыхания насаждения
              </th>
              <th style={{ 
                minWidth: '400px', 
                width: '400px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                Информация пользователя
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '500'
              }}>
                <div 
                  className="reference-cell"
                  onClick={openDryingCharacterPicker}
                  style={{
                    width: '100%',
                    height: '100%',
                    minHeight: '40px',
                    cursor: 'pointer',
                    background: 'transparent',
                    border: 'none',
                    padding: '0',
                    margin: '0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    fontSize: '14px'
                  }}
                >
                  <span style={{ 
                    color: displayData.charochag ? '#000' : '#6c757d',
                    flex: 1,
                    padding: '8px'
                  }}>
                    {(() => {
                      const handbook = handbooks.find(h => h.id === 20);
                      if (handbook && handbook.references && displayData.charochag) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === displayData.charochag);
                        return selectedOption ? selectedOption.name : 'Выберите характер усыхания';
                      }
                      return 'Выберите характер усыхания';
                    })()}
                  </span>
                  <span style={{ color: '#6c757d', fontSize: '12px', paddingRight: '8px' }}>☰</span>
                </div>
              </td>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '500'
              }}>
                <textarea
                  value={displayData.itaks4 || ''}
                  onChange={handleUserInfoChange}
                  placeholder="Введите дополнительную информацию..."
                  style={{
                    width: '100%',
                    minHeight: '40px',
                    padding: '8px',
                    border: 'none',
                    borderRadius: '0',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DryingCharacterSection;

